(function($){
  $(document).ready(function() {


    $('.les-recettes').slick({
        autoplay: true,
        autoplaySpeed: 6000,
        arrows: false,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
    });

    $('body').on('click','.afficher-commande', function(e){
        e.preventDefault();
        var commande = $(this).data('commande');
        $.ajax({
          url: '/inc/xhr/actions.php?action=afficher_commande&commande='+commande,
          success: function(data) {
            $.popin.alert({title: "Votre commande", message: data, button: "fermer"});
            }
          });
    });

    $('.creer-commande').click(function(e){
        e.preventDefault();
        var livraison = $(this).data('livraison');
            //alert($("#lien_commande_"+livraison).html());

        $.ajax({
          url: '/inc/xhr/actions.php?action=creer_commande&livraison='+livraison,
          success: function(data) {

            lien = "<a href='#' data-commande=\""+data+"\" class=\"afficher-commande\">Voir / modifier</a>";
            $("#lien_commande_"+livraison).html(lien);
            // alert("#lien_commande_"+livraison);
            // alert(lien);

            $.ajax({
              url: '/inc/xhr/actions.php?action=afficher_commande&commande='+data,
              success: function(data) {
                $.popin.alert({title: "Votre commande", message: data, button: "fermer"});
                }
              });

            }
          });
    });

    $('.afficher-recette').click(function(e){
        e.preventDefault();
        var id = $(this).data('id');
        $.ajax({
          url: '/inc/xhr/actions.php?action=afficher_recette&id='+id,
          success: function(data) {

            $("#recette").html(data);

            }
          });
    });

    if($('.popinmessage').html() != undefined && $('.popinmessage').html().trim() != '') {
      console.log('>'+$('.popinmessage').html()+'<');
      $.popin.alert({type: $('.popinmessage').data('type'),title: $('.popinmessage').data('title'), message: $('.popinmessage').html(), button: $('.popinmessage').data('button')});
    }


  })
})(jQuery);